import { createSlice } from "@reduxjs/toolkit";
import { setIsFreightForwarder, setLogisticsCachingHandler, setPortCategory, setProfileMapData, setProfileRedirectionId, setTabDetails } from "./logisticsProfile.action";
import { logisticsTabData } from "@components/templates/Profile/ProfileHeader/profile-enum";

let logisticsCaching = {
  overview: {
    trade_country: null,
    trade_lane: null,
    trade_port: null,
    location: null,
  },
  importers: null,
  exporters: null,
  profileDetails: {},
};

const logisticsProfileSlice = createSlice({
  name: "logisticsProfile",
  initialState: {
    countDetails: {
      loading: true,
    },
    portCategory: null,
    tabDetails: {
      activePanelId: "",
      activeTabId: logisticsTabData[0].id,
      mapType: "trade_countries",
    },
    profileRedirectionId: "",
    logisticsCaching: { ...logisticsCaching },
  },
  reducers: {
    profileMapDataHandler: setProfileMapData,
    portCategoryHandler: setPortCategory,
    tabDetailsHandler: setTabDetails,
    profileRedirectionIdHandler: setProfileRedirectionId,
    isFreightForwarderHandler: setIsFreightForwarder,
    logisticsCachingHandler: setLogisticsCachingHandler,
  },
});

export const { profileMapDataHandler, portCategoryHandler, tabDetailsHandler, profileRedirectionIdHandler, isFreightForwarderHandler, logisticsCachingHandler } = logisticsProfileSlice.actions;

export default logisticsProfileSlice.reducer;
